import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#19353C",
        secondary: "#0D0F14",
        accent: "#8c9eff",
        error: "#b71c1c",
      },
    },
  },
});
